<template>
  <!--TODO-->
  <tr>
    <td colspan="3">
      <CustomAlert
        type="warning"
        :withIcon="false"
        class="confection-inputs logo-alert mb-0 text-left font-weight-normal"
      >
        <p>
          Jeśli chcesz złożyć zamówienie z opcją “Personalizacja na maxa - logo Twojej firmy w
          aplikacji Pluxee” wyślij wypełniony <a href="https://www.pluxee.pl/panel-klienta-b2b/formularze-zamowien/" rel="noopener" target="_blank">formularz excel</a> do Centrum Obsługi Klienta
          Pluxee -
          <a href="mailto:kontakt@cok.pluxee.pl">kontakt@cok.pluxee.pl</a>
        </p>
        <p class="mb-0">
          <a href="https://www.pluxee.pl/panel-klienta-b2b/formularze-zamowien/" rel="noopener" target="_blank">Formularz excel</a>
        </p>
      </CustomAlert>
    </td>
  </tr>
</template>

<script>
import CustomAlert from './CustomAlert.vue';

export default {
  name: 'LogoPersonalizationAlert',
  components: {
    CustomAlert,
  },
};
</script>

<style lang="scss" scoped>
.logo-alert {
  font-size: 1.3rem;
}
</style>
